(() => {
  if (customElements.get('kakavy-discount-offer')) return;
  class KakavyDiscountOffer extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.button = this.querySelector('button');
      this.status = this.querySelector('[role="status"]');
      this.variants = JSON.parse(this.querySelector('[data-offer-variants]').textContent);
      this.button.addEventListener('click', () => this.copyCode(), {signal: this.controller.signal});
      const form = document.getElementById(this.getAttribute('form-id'));
      form?.addEventListener('variant:change', event => {
        const variant = this.variants[String(event.detail.variant?.id)];
        this.hidden = !variant?.available;
        if (variant && this.querySelector('[data-offer-price]')) this.querySelector('[data-offer-price]').textContent = variant.price;
      }, {signal: this.controller.signal});
    }
    disconnectedCallback() {
      this.controller?.abort();
      clearTimeout(this.resetTimer);
    }
    async copyCode() {
      const code = this.dataset.code;
      let copied = false;
      try {
        await navigator.clipboard.writeText(code);
        copied = true;
      } catch {
        const input = document.createElement('textarea');
        input.value = code;
        input.setAttribute('readonly', '');
        input.style.cssText = 'position:fixed;left:-9999px;top:0;font-size:16px';
        this.append(input);
        input.select();
        try {copied = document.execCommand('copy');} catch {}
        input.remove();
        this.button.focus({preventScroll:true});
      }
      clearTimeout(this.resetTimer);
      this.button.textContent = copied ? this.button.dataset.copiedLabel : this.button.dataset.copyLabel;
      this.status.textContent = copied ? `${this.button.dataset.copiedLabel}: ${code}` : `${this.status.dataset.fallbackLabel} ${code}`;
      if (copied) this.resetTimer = setTimeout(() => {
        this.button.textContent = this.button.dataset.copyLabel;
        this.status.textContent = '';
      }, 3000);
    }
  }
  customElements.define('kakavy-discount-offer', KakavyDiscountOffer);
})();
